import { useEpisodeReplyState } from 'contexts/EpisodeReplyProvider';
import { useGetRelayContentRepliesInfiniteQuery } from 'queries/reply/useGetRelayContentRepliesInfiniteQuery';
import React, { useEffect } from 'react';
import { useGetReplyInfo } from 'state-hooks/reply/useGetReplyInfo';
import { InfiniteScrollWrapper } from 'ui-components/common/InfiniteScrollWrapper';
import { FullPageLoading } from 'ui-components/common/Loading';
import { showToast } from 'utils/modal';
import { ReplyList } from 'app-components/reply/list/ReplyList';
import styled from '@emotion/styled';
import { RepliesRelayResponseDto } from '@diritto/common/relay/dtos/reply-relay.dtos';

export const ContentReplyListView = () => {
  const { orderBy, contentId } = useEpisodeReplyState();
  const replyQuery = useGetRelayContentRepliesInfiniteQuery(contentId, orderBy);
  const { profiles, contents, replies, likeReplyIds, episodes, focusedReplyId, focusedReply } =
    useGetReplyInfo<RepliesRelayResponseDto>(replyQuery);

  useEffect(() => {
    if (focusedReply?.isDeleted) {
      showToast('댓글이 삭제되었어요.');
    }
  }, [focusedReply?.isDeleted]);

  return (
    <StyledInfiniteScrollWrapper loadMore={replyQuery.fetchNextPage} hasNext={replyQuery.hasNextPage}>
      {replyQuery.isLoading && <FullPageLoading relative />}
      <ReplyList
        profiles={profiles}
        contents={contents}
        replies={replies}
        episodes={episodes}
        likeReplyIds={likeReplyIds}
        focusedReplyId={focusedReplyId}
        myReplyEditable={false} // 전체 댓글일때 내댓글인 경우에만 config menu 를 숨김
        myReplyDeletable
        showReReplyCount
        showReReplyWrite
        showMyReplyStyle
        showPinned
        emptyDescription={'댓글은 작가님께 힘이돼요!'}
        emptyTitle={'첫 댓글을 남겨보세요.'}
      />
    </StyledInfiniteScrollWrapper>
  );
};

const StyledInfiniteScrollWrapper = styled(InfiniteScrollWrapper)`
  margin-bottom: 200px;
`;
